import { m, AnimatePresence } from "framer-motion";
// @mui
import {
  Dialog,
  Box,
  Paper,
  DialogProps,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import { useMemo } from "react";
import { varFade } from "./variants";
import Iconify from "../iconify";

// ----------------------------------------------------------------------

export interface Props extends DialogProps {
  variants?: Record<string, unknown>;
  onClose?: VoidFunction;
  title?: string;
}

export default function DialogAnimate({
  open = false,
  variants,
  onClose,
  title,
  children,
  sx,
  ...other
}: Props) {
  // memoiza somente uma vez as variantes padrão
  const defaultVariants = useMemo(
    () =>
      varFade({
        distance: 120,
        durationIn: 0.32,
        durationOut: 0.24,
        easeIn: "easeInOut",
      }).inUp,
    []
  );

  return (
    <AnimatePresence initial={false} exitBeforeEnter>
      {open && (
        <Dialog
          fullWidth
          maxWidth="xs"
          open={open}
          onClose={onClose}
          PaperComponent={(props) => (
            <Box
              component={m.div}
              {...(variants || defaultVariants)}
              initial="initial"
              animate="animate"
              exit="exit"
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "transparent",
              }}
            >
              <Box
                onClick={onClose}
                sx={{ width: "100%", height: "100%", position: "fixed" }}
              />
              <Card sx={{ ...sx }} {...props}>
                <CardHeader title={title || ""} />
                <Iconify
                  icon="material-symbols:close-rounded"
                  width="22px"
                  sx={{ position: "absolute", top: 20, right: 20 }}
                  onClick={onClose}
                />
                <CardContent sx={{ width: "100%", height: "100%" }}>
                  {props.children}
                </CardContent>
              </Card>
            </Box>
          )}
          {...other}
        >
          {children}
        </Dialog>
      )}
    </AnimatePresence>
  );
}
